import React, {useEffect, useState} from "react";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import List from "@material-ui/core/List";
import {makeStyles} from "@material-ui/core";
import {useOrganization} from "../organizations/organization-context";
import {GreyedOutProgressMask} from "../ui/GreyedOutProgressMask";
import {FoldersBrowserItem} from "./FoldersBrowserItem";
import {getFoldersWithChildren, getTopFolders, getTopFoldersWithChildren} from "../../api/pro-guest-functions";
import {run} from "../../utils/function-util";
import {useApiNotification} from "../ui/ApiNotificationProvider";

const useStyles = makeStyles(theme => ({
    topSpacer: {
        ...theme.mixins.toolbar,
    },
    drawerPaper: {
        position: 'static',
        minWidth: 300
    },
    listPadding: {
        padding: '0'
    }
}));
export const FoldersBrowser = (props: any) => {
    const classes = useStyles();
    const [currentOrganization] = useOrganization();
    const [browserIsLoading, setBrowserIsLoading] = useState(false);
    const [folders, setFolders] = useState([]);
    const currentFolderId = props.folderId;
    const raiseFolderIdChanged = props.onFolderIdChanged;
    const { handleError } = useApiNotification();

    useEffect(run(async () => currentOrganization ? await loadFolders(currentOrganization.id, currentFolderId) : Promise.resolve([]), setFolders, handleError, () => setBrowserIsLoading(false)), [currentOrganization, currentFolderId]);

    if(!currentOrganization) return null;

    const loadFolders = async (organizationId: any, folderId: any) => {
        setBrowserIsLoading(true);
        const topFolders = await getTopFolders(organizationId);
        const topFolderIds = new Set<number>(topFolders.map((f: any) => f.id));
        if (folderId && topFolderIds.has(folderId)) {
            return getTopFoldersWithChildren(organizationId, folderId, topFolderIds);
        }
        else {
            return getFoldersWithChildren(organizationId, currentFolderId, topFolderIds);
        }
    };
       return (<GreyedOutProgressMask isActive={browserIsLoading} displaySpinner={true}>
                        <Drawer key='organization-unit-browser' variant='permanent' classes={{ paper: clsx(classes.drawerPaper) }}>
                                <List classes={{ padding: clsx(classes.listPadding) }}>
                                        {folders && folders.map(folder => <FoldersBrowserItem onFolderIdChanged={raiseFolderIdChanged} key={`organization-unit-list-item-${(folder as any).id}`} organizationId={currentOrganization.id} folder={folder} isDisplayedAsChild={false}/>)}
                </List>
            </Drawer>
        </GreyedOutProgressMask>);
};
